import { makeStyles, ClickAwayListener } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LanguageContext from '../../../contexts/languageContext';
import MessagesContext from '../../../contexts/messagesContext';
import { getForms } from '../../../redux/DynamicForms/DynamicFormsAction';
import { getNamespace } from '../../../utils/storage';
import { SearchableSelect } from '../../UI';
import { CloseIcon, DropDownIcon } from '../../UI/Images/Icons';
import { PropTypes } from 'prop-types';

const styles = makeStyles({
    selectionForm: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '36px',
        maxWidth: '300px',
        position: 'relative'
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        position: 'absolute',
        zIndex: 2
    },
    selectInputWrapper: {
        height: '50px',
        position: 'absolute',
        zIndex: 1
    },
    inputRoot: {
        width: '50px',
        opacity: 0
    },
    paper: {
        width: '200px'
    },
    popper: {
        direction: ({ rtl }) => (rtl ? 'rtl' : 'ltr')
    },
    formValueWrapper: {
        minWidth: '100px',
        padding: '5px',
        border: '1px solid #ced2d6',
        borderRadius: '5px',
        position: 'absolute',
        right: '80px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& svg': {
            cursor: 'pointer'
        }
    }
});
const SelectFormType = ({ setFormValue, formValue }) => {
    const { lang } = useContext(LanguageContext);
    const classes = styles({ rtl: lang === 'fa' });
    const { messages } = useContext(MessagesContext);
    const [open, setOpen] = useState(false);
    const [data, setData] = useState([]);
    const dispatch = useDispatch();
    const allForms = useSelector((state) => state.dynamicForms.allForms);

    useEffect(() => {
        const namespace = getNamespace();
        if (namespace && !allForms) {
            dispatch(getForms(namespace));
        }
    }, []);
    useEffect(() => {
        if (allForms?.length) {
            setData(allForms?.map((item) => ({ id: item.name, name: item.title })));
        }
    }, [allForms]);
    return (
        <>
            <div className={classes.selectionForm}>
                <ClickAwayListener onClickAway={() => setOpen(false)}>
                    <div className={classes.title} onClick={() => setOpen(!open)}>
                        <span>{messages.formType}</span>
                        <DropDownIcon />
                    </div>
                </ClickAwayListener>
                <div className={classes.selectInputWrapper}>
                    <SearchableSelect
                        width="100%"
                        optionsDirection="ltr"
                        optionalToUse
                        options={data}
                        optionsLabel="name"
                        name="type"
                        openWithCustomInput={open}
                        customClasses={classes}
                        setValue={(value) => {
                            const findValue = data?.find((item) => item?.id === value);
                            setFormValue(findValue);
                        }}
                    />
                </div>
                {formValue?.id && (
                    <div className={classes.formValueWrapper}>
                        <span>{formValue?.name}</span>
                        <CloseIcon onClick={() => setFormValue({})} />
                    </div>
                )}
            </div>
        </>
    );
};
SelectFormType.propTypes = {
    setFormValue: PropTypes.function,
    formValue: PropTypes.object
};
export default SelectFormType;
